import React, { useState } from 'react';
import { Mail, Lock, User, ArrowRight, Briefcase, Users, Crown } from 'lucide-react';
import './Login.css';
import { API_URL } from './API';

const Login = ({ onLoginSuccess }) => {
  const [activeTab, setActiveTab] = useState('employee');
  const [currentForm, setCurrentForm] = useState('login');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setErrorMessage('');

    if (currentForm === 'login') {
      if (!formData.email || !formData.password) {
        setErrorMessage('Please enter both email and password');
        setIsLoading(false);
        return;
      }

      try {
        const endpoint = '/auth/login';

        const response = await fetch(`${API_URL}${endpoint}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password
          })
        });

        const result = await response.json();





if (response.ok) {
  const userData = result.response_model || result.user || result;
  
  const userRole = userData.role ? userData.role.toUpperCase() : '';
  const isFullAccessUser = userData.access_level === 'full' || 
                           userRole.includes('CEO') || 
                           userRole.includes('ADMIN');
  
  const isClient = activeTab === 'client' || 
                   userData.user_type === 'client' || 
                   userData.client_id;
  
  localStorage.setItem('currentUser', JSON.stringify(userData));
  localStorage.setItem('currentUserEmail', formData.email);
  localStorage.setItem('currentUserName', userData.name || 'User');
  localStorage.setItem('currentUserId', userData.employee_id || userData.client_id || userData.id || '1');
  localStorage.setItem('currentUserRole', userData.role || activeTab);
  
  if (isFullAccessUser) {
    localStorage.setItem('accessLevel', 'full');
    localStorage.setItem('userType', 'employee');
    
    
    if (userData.employees_data && Array.isArray(userData.employees_data)) {
      localStorage.setItem('allEmployeesData', JSON.stringify(userData.employees_data));
     
    }
  } 
  else if (isClient) {
    localStorage.setItem('accessLevel', 'client');
    localStorage.setItem('userType', 'client');
    localStorage.setItem('currentClientId', userData.client_id || userData.id);
    
    
  } 
  else {
    localStorage.setItem('accessLevel', 'self_only');
    localStorage.setItem('userType', 'employee');
  }
  
  if (result.accesstoken || result.token) {
    localStorage.setItem('authToken', result.accesstoken || result.token);
  }

 
  

  if (onLoginSuccess) {
    onLoginSuccess(userData);
  }
}
        else {
          setErrorMessage(result.message || 'Login failed. Please check your credentials.');
        }
      } catch (error) {
     
        setErrorMessage('Network error. Please try again.');
      }
    } else if (currentForm === 'signup') {
      if (!formData.email || !formData.password || !formData.fullName || !formData.confirmPassword) {
        setErrorMessage('Please fill in all fields');
        setIsLoading(false);
        return;
      }

      if (formData.password !== formData.confirmPassword) {
        setErrorMessage('Passwords do not match');
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.fullName,
            email: formData.email,
            password: formData.password,
            type: activeTab
          })
        });

        const result = await response.json();

        if (response.ok) {
          setErrorMessage('Registration successful! Please login.');
          setCurrentForm('login');
          resetForm();
        } else {
          setErrorMessage(result.message || 'Registration failed. Please try again.');
        }
      } catch (error) {
        
        setErrorMessage('Network error. Please try again.');
      }
    } else if (currentForm === 'forgot') {
      if (!formData.email) {
        setErrorMessage('Please enter your email address');
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/forgot-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: formData.email
          })
        });

        const result = await response.json();

        if (response.ok) {
          setErrorMessage('Password reset link sent to your email!');
          setTimeout(() => {
            setCurrentForm('login');
            resetForm();
          }, 2000);
        } else {
          setErrorMessage(result.message || 'Failed to send reset link. Please try again.');
        }
      } catch (error) {
      
        setErrorMessage('Network error. Please try again.');
      }
    }

    setIsLoading(false);
  };

  const resetForm = () => {
    setFormData({
      email: '',
      password: '',
      confirmPassword: '',
      fullName: ''
    });
    setErrorMessage('');
  };

  const switchForm = (formType) => {
    setCurrentForm(formType);
    resetForm();
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    resetForm();
    setCurrentForm('login');
  };

  return (
    <div className="LO-00">
      <div className="LO-01">
        <div className="LO-02"></div>
        <div className="LO-03"></div>
        <div className="LO-04"></div>
      </div>
      
      <div className="LO-05">
        <div className="LO-06">
         

          <div className="LO-10">
            <h1 className="LO-11">
              {currentForm === 'login' && 'Welcome Back'}
              {currentForm === 'signup' && 'Create Account'}
              {currentForm === 'forgot' && 'Reset Password'}
            </h1>
            <p className="LO-12">
              {currentForm === 'login' && `Sign in `}
              {currentForm === 'signup' && 'Join us today'}
              {currentForm === 'forgot' && 'Enter your email to reset password'}
            </p>
          </div>

          {errorMessage && (
            <div className={errorMessage.includes('successful') ? 'LO-13 LO-14' : 'LO-13 LO-15'}>
              {errorMessage}
            </div>
          )}

          <div className="LO-16">
            {currentForm === 'signup' && (
              <div className="LO-17">
                <div className="LO-18">
                  <User className="LO-19" size={20} />
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="LO-20"
                    required
                  />
                </div>
              </div>
            )}

            <div className="LO-17">
              <div className="LO-18">
                <Mail className="LO-19" size={20} />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="LO-20"
                  required
                />
              </div>
            </div>

            {currentForm !== 'forgot' && (
              <div className="LO-17">
                <div className="LO-18">
                  <Lock className="LO-19" size={20} />
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="LO-20"
                    required
                  />
                </div>
              </div>
            )}

            {currentForm === 'signup' && (
              <div className="LO-17">
                <div className="LO-18">
                  <Lock className="LO-19" size={20} />
                  <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    className="LO-20"
                    required
                  />
                </div>
              </div>
            )}

            {currentForm === 'login' && (
              <div className="LO-21">
                <button
                  type="button"
                  onClick={() => switchForm('forgot')}
                  className="LO-22"
                >
                  Forgot your password?
                </button>
              </div>
            )}

            <button 
              onClick={handleSubmit}
              type="button" 
              className="LO-23"
              disabled={isLoading}
            >
              <span>
                {isLoading ? 'Please wait...' : (
                  <>
                    {currentForm === 'login' && 'Sign In'}
                    {currentForm === 'signup' && 'Create Account'}
                    {currentForm === 'forgot' && 'Send Reset Link'}
                  </>
                )}
              </span>
              {!isLoading && <ArrowRight className="LO-24" size={20} />}
            </button>
          </div>

       
        </div>
      </div>
    </div>
  );
};

export default Login;



